'use client';

import type { Translations } from '@eliadmin/core/src/api/general/types/translation-types';
import { useTranslationSnapshot } from '@eliadmin/core/src/i18n/translation-context';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import type { StringWithAutocomplete } from '@eliadmin/core/src/types/misc-types';
import { hasTranslationKeys } from '@eliadmin/core/src/utils/translation-readiness';
import { useCallback } from 'react';
export type TranslateFn = (key: StringWithAutocomplete<keyof Translations>) => string;

export function useTranslations(): { t: TranslateFn; isReady: boolean } {
  const generatedTranslations = useTranslationSnapshot();
  const storedTranslations = useGlobalStore(state => state.translations);
  const translations = generatedTranslations ?? storedTranslations;
  const isReady = generatedTranslations !== null || hasTranslationKeys(storedTranslations);

  const t: TranslateFn = useCallback(
    key => {
      return (
        translations?.[key as keyof Translations] ||
        (process.env.NODE_ENV === 'development'
          ? key
          : key?.startsWith('text')
            ? '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'
            : key)
      );
    },
    [translations],
  );

  return { t, isReady };
}
